module.exports = __webpack_public_path__ + "static/10-e19db41e879a1402c2dc234689101cd8.jpg";